import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
	selector: 'adf-loading-spinner',
	standalone: true,
	imports: [],
	templateUrl: './loading-spinner.component.html',
	styleUrl: './loading-spinner.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingSpinnerComponent {
	size = input<string>('2rem');
	colorCls = input<string>('text-primary');
	visible = input<boolean>(true);
}
